// removed by extract-text-webpack-plugin
module.exports = {"loadMore":"c-OrderHistoryList__loadMore","wrapper":"c-OrderHistoryList__wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/OrderHistoryList/OrderHistoryList.scss
// module id = 736
// module chunks = 0